module.exports = __webpack_public_path__ + "img/h_1.c7558669.jpg";